import axios from 'axios';
import { ensureHttps } from './config';

const isLocalDev = typeof window !== 'undefined' && 
                  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const BASE_URL = isLocalDev 
  ? 'http://localhost:8084'
  : 'https://erp.escooterlab.ch/business-process-management';

const API_URL = `${BASE_URL}/api/v1`;

const dropOffApprovalApi = {
  /**
   * Get all pending drop-off approval requests
   */
  getPendingApprovals: async () => {
    try {
      const response = await axios.get(`${API_URL}/drop-off-approvals/pending`);
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error('Error fetching pending drop-off approvals:', error);
      return [];
    }
  },

  /**
   * Approve a pending drop-off verification
   * @param {number} verificationId 
   */
  approve: async (verificationId) => {
    const response = await axios.post(`${API_URL}/drop-off-approvals/${verificationId}/approve`);
    return response.data;
  },

  /**
   * Decline a pending drop-off verification
   * @param {number} verificationId 
   */
  decline: async (verificationId) => {
    const response = await axios.post(`${API_URL}/drop-off-approvals/${verificationId}/decline`);
    return response.data;
  },
};

export default dropOffApprovalApi;
